import React from "react";
import { FormattedMessage } from "@/i18n/i18n-client";
import { EcommerceReceipt } from "@/assets/Icons/EcommerceReceipt";
import AddAddress from "./AddAddress";

const AddressesEmptyState = () => {
  return (
    <div className="flex flex-col items-center justify-center gap-sm">
      <EcommerceReceipt />
      <div className="flex flex-col items-center justify-center gap-xs">
        <div className="flex flex-col items-center justify-center">
          <span className="text-text-lg font-bold">
            <FormattedMessage
              defaultMessage="There are no addresses yet!"
              id="JP32uk"
            />
          </span>
          <span className="text-text-sm">
            <FormattedMessage
              defaultMessage="Add your addresses and we will save it for you in next purchases"
              id="RvWGrt"
            />
          </span>
        </div>
        <AddAddress />
      </div>
    </div>
  );
};

export default AddressesEmptyState;
